import FacilitySelectLabel from './FacilitySelectLabel';

export default FacilitySelectLabel;
